import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

import { ReactComponent as SpinIcon } from './icon-spin.svg';

import './Button.scss';

export interface ButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
  appearance: 'primary' | 'secondary' | 'tertiary' | 'caption' | 'border';
  children: ReactNode;
  size: 'small' | 'medium' | 'large';
  disabled?: boolean;
  isLoading?: boolean;
  linkProps?: {
    href: string;
    type: 'external' | 'internal';
  };
}

const Button = ({ children, appearance, size, isLoading, linkProps, ...props }: ButtonProps): JSX.Element => {
  const getButton = () => (
    <button
      disabled={isLoading}
      {...props}
      className={`btn ${props.className}
      ${appearance || ''}
      ${size || ''}`}
    >
      {isLoading ? (
        <motion.svg
          animate={{ rotate: -360 }}
          className='button-spin'
          transition={{
            duration: 0.5,
            ease: 'linear',
            repeat: Infinity,
          }}
        >
          <SpinIcon />
        </motion.svg>
      ) : (
        children
      )}
    </button>
  );

  if (linkProps?.type === 'internal')
    return (
      <a className={props?.className} href={linkProps?.href}>
        {getButton()}
      </a>
    );

  if (linkProps?.type === 'external')
    return (
      <a className={props?.className} href={linkProps?.href} rel='noreferrer' target='_blank'>
        {getButton()}
      </a>
    );

  return getButton();
};

export default Button;
